import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Point } from 'assets'
import { Img } from 'styles/GlobalStyle'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { FabButtonStyles, Step3Styles } from './Style'
import { AnimatePresence } from "motion/react"
import { ReactComponent as MicIcon } from 'assets/icons/Mic.svg';
import { IconButton, SvgIcon } from '@mui/material'
import { Pause, PlayArrow } from '@mui/icons-material'
import { visibleTypes } from 'keys'
import { CheckPermissions } from '.'
import * as motion from "motion/react-client"
import ReactPlayer from 'react-player'
import { screen_3_narrative_text_click_and_start_female, screen_3_narrative_text_click_and_start_male, screen_3_word_list_click_and_start_female, screen_3_word_list_click_and_start_male } from 'record1'

const Step3 = () => {
    const { isMaleGender, micDisabled, assessmentDef, setMicDisabled, setReadAloudFlag, setCurrentStep } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [disabledNext, setDisabledNext] = useState(true)

    const assessmentDefItem = {
        [visibleTypes.PARAGRAPH]: {
            record: isMaleGender ? screen_3_narrative_text_click_and_start_male : screen_3_narrative_text_click_and_start_female,
            assessmentId: null
        },
        [visibleTypes.WORD_GROUP]: {
            record: isMaleGender ? screen_3_word_list_click_and_start_male : screen_3_word_list_click_and_start_female,
            assessmentId: 40
        }
    }

    const item = assessmentDefItem?.[assessmentDef?.visible_type]

    const getMicPermission = useCallback(() => {
        navigator.getUserMedia = (navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
        navigator.getUserMedia({ audio: true },
            () => {
                return true
            },
            () => {
                setMicDisabled(true)
                return false
            }
        );
    }, [])

    const goNextStep = useCallback(async () => {
        navigator.getUserMedia = (
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        )
        navigator.getUserMedia({ audio: true },
            () => {
                navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
                    setReadAloudFlag(true)
                    setShouldAnimate(true)
                    setCartoonSpeaking(false)
                    setTimeout(() => {
                        setCurrentStep(currentStep => currentStep + 1)
                    }, 1300)
                }, () => setMicDisabled(true))
            },
            () => setMicDisabled(true)
        );
    }, [])

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    useEffect(() => {
        setTimeout(() => {
            setDisabledNext(false)
        }, 2000);
    }, [])

    return (
        <Step3Styles>
            {micDisabled ?
                <CheckPermissions checkPermissions={getMicPermission} /> :
                <React.Fragment>
                    <div className='wrap-content'>
                        <AnimatePresence>
                            {!shouldAnimate ? (

                                <div className='wrap-cartoon-img'>
                                    <motion.div
                                        initial={{ opacity: 0 }} // מתחיל מחוץ למסך משמאל
                                        animate={{ y: 1, x: 1, opacity: 1 }} // נכנס למקום שלו
                                        exit={{ opacity: 0 }} // יוצא מהמסך משמאל
                                        transition={{ duration: 0.7 }}
                                        className='cartoon-img'
                                        key="cartoon-img"
                                    >
                                        <Img src={cartoonSpeaking ? Point : Point} />
                                        <div className='play-pause-cartoon'>
                                            <IconButton onClick={handleCartoonSpeaking}>
                                                {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                            </IconButton>
                                        </div>
                                    </motion.div>
                                </div>
                            ) : null}
                        </AnimatePresence>
                        <AnimatePresence>
                            {!shouldAnimate ? (
                                <motion.div
                                    initial={{ opacity: 0.4 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0.4 }}
                                    transition={{ duration: 0.7 }}
                                    className='mic-img'
                                    key="mic-img"

                                >
                                    <div className='wrap-fab-button'>
                                        <FabButtonStyles fill="transparent" stroke="white">
                                            <IconButton
                                                onClick={goNextStep}
                                                disabled={disabledNext}>
                                                <SvgIcon fontSize='small' component={MicIcon} inheritViewBox />
                                            </IconButton>
                                        </FabButtonStyles>
                                    </div>
                                </motion.div>
                            ) : null}
                        </AnimatePresence>
                    </div>
                    <ReactPlayer
                        playing={cartoonSpeaking}
                        url={item?.record}
                        width='0px' height='0px'
                        onEnded={() => setCartoonSpeaking(false)}
                    />
                </React.Fragment>}
        </Step3Styles>
    )
}

export default Step3